<template>
    <div class="col-12 col-xl-11 mx-auto content-box bg-white-like mb-4 book-details-page">
        <div class="row bg-main ">
            <div :class="bookPhoto.includes('default') ? 'col-sm-3 col-lg-2 col-xl-2': 'col-sm-4 col-lg-3 col-xl-3' + ' col-12 px-0 text-center text-md-start'">
                <img :src="bookPhoto" :alt="bookData.name" :class="bookPhoto.includes('default') ? 'book-image-default' : 'book-image'">
            </div>
            <div class="my-3 col-12 col-sm-8 col-lg-5 col-xl-5" :class="bookPhoto.includes('default') ? 'col-sm-9 col-lg-6 col-xl-6': 'col-sm-8 col-lg-5 col-xl-5'">
                <h2 class="h3-like mb-0">{{ bookData.name }}</h2>

                <p class="lh-sm">{{ bookData.description }}</p>

                <p class="darkgrey">{{ poisCount > 1 ? poisCount + ' adresses' : poisCount + ' adresse' }}</p>

                <div class="d-flex book-creator position-relative user-container w-100">
                    <user-popin-component v-if="bookAuthor" :unique-id="Math.floor(Math.random() * 100000).toString()" :user-id="bookData.user_id">
                        <img :src="bookAuthorAvatar" :alt="bookData.name" class="user-picture">
                    </user-popin-component>

                    <div class="ms-3">
                        <p v-if="bookAuthor" class="lh-sm mb-0 position-relative w-100 me-0s">
                            <user-popin-component :unique-id="Math.floor(Math.random() * 100000).toString()" :user-id="bookData.user_id">
                                <span class="me-1">Créé par</span><span class="link-like text-capitalize">{{ bookAuthor.name }},</span><span> le {{ formatDate(bookData.created_at) }}</span>
                            </user-popin-component>
                        </p>

                        <p class="lh-sm mb-0">Mis à jour le {{ formatDate(bookData.updated_at) }}</p>
                        <p class="lh-sm mb-0">Ce carnet est {{ bookData.is_visible ? 'public' : 'privé' }} et {{ bookData.is_editable ? 'modifiable' : 'non-modifiable' }}</p>
                    </div>
                </div>

                <div class="d-flex mt-4">
                    <vote-useful-component
                        :unique-id-part1="Math.floor(Math.random() * 1000)"
                        :unique-id-part2="Math.floor(Math.random() * 1000)"
                        :unique-id-part3="Math.floor(Math.random() * 1000)"
                        :useful-count="useful[0]"
                        model-type="book"
                        :model-id="bookData.id"
                        :receiver-id="bookData.user_id"
                        :giver-id="userId ? userId : null"
                        :user-auth="userConnected"
                        :voters-useful="useful[1]"
                    ></vote-useful-component>
                </div>
            </div>

            <div class="col-12 col-lg-4 col-xl-4 book-actions mt-2 mb-3">
                <div v-if="userCreator">
                    <div class="d-flex">
                        <span class="icon edit-photo"></span>
                        <a :href="route('books.edit', bookData.id)">Modifier le carnet</a>
                    </div>

                    <div class="d-flex">
                        <span class="icon delete"></span>
                        <a :href="route('books.delete', bookData.id)">Supprimer le carnet</a>
                    </div>
                </div>

                <div v-if="userConnected">
                    <div class="d-flex">
                        <span class="icon follow"></span>
                        <a class="teal" @click.prevent="followBook()">{{ userFollowsBookData ? 'Ne plus suivre' : 'Suivre ce carnet' }}</a>
                    </div>
                </div>

                <div v-else>
                    <div class="d-flex">
                        <span class="icon follow"></span>
                        <a data-bs-toggle="modal" data-bs-target="#connexion" class="teal">Suivre ce carnet</a>
                    </div>
                </div>

                <div class="d-flex">
                    <span class="icon comment"></span>
                    <a href="#bookComments" title="Commentaires">Commentaires</a>
                </div>

                <div class="search-input-block pe-2 pb-2 mt-3 position-relative">
                    <label for="filter-addresses" class="d-none">Filtrer les adresses</label>
                    <div @click="filterMenuVisible = !filterMenuVisible" class="position-fixed clickOutFilter top-0 bottom-0 start-0 end-0" :class="filterMenuVisible ? 'd-block' : 'd-none'"></div>

                    <div class="d-flex flex-row position-relative filter-addresses-wrapper" @click="filterMenuVisible = !filterMenuVisible">
                        <input @input="searchFilter($event)" id="filter-addresses" type="text" class="form-control input input-text" placeholder="Filtrer les adresses">
                        <button class="bg-teal search-button search-button me-1">
                            <svg width="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="text-white"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"></path></svg>
                        </button>
                        <div class="position-absolute bottom-0 filter-addresses-menu p-3" :class="filterMenuVisible ? 'd-block' : 'd-none'">
                            <ul v-if="filterCategoryList.length" class="list-unstyled">
                                <li class="fw-bold mb-1">Affiner par rubrique</li>
                                <li v-for="(category, index) in filterCategoryList"
                                    :key="'category'+index">
                                    <a href="" @click.prevent="setFilterToVisiblecardsList('category',category)">{{ category }}</a>
                                </li>
                            </ul>

                            <ul v-if="filterCityList.length" class="list-unstyled">
                                <li class="fw-bold mb-1">Affiner par ville</li>
                                <li v-for="(city, index) in filterCityList"
                                    :key="'city'+index">
                                    <a href="" @click.prevent="setFilterToVisiblecardsList('city',city)">{{ city }}</a>
                                </li>
                            </ul>

                            <ul v-if="filterDepartmentList.length" class="list-unstyled">
                                <li class="fw-bold mb-1">Affiner par département</li>
                                <li v-for="(department, index) in filterDepartmentList"
                                    :key="'department'+index">
                                    <a href="" @click.prevent="setFilterToVisiblecardsList('department',department)">{{ department }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-3">
                <div class="d-flex flex-row justify-content-start py-1 mb-3">
                    <div class="me-2 px-1 bg-main border border-info rounded-2 my-auto" v-for="(criteria, criteriaIndex) of visibleCriterias" :key="'filterCriteria' + criteriaIndex">
                        <p class="mb-0">{{ criteria.name }}<a href="" @click.prevent="setFilterToVisiblecardsList(criteria.type, criteria.name, false)" class="ms-2">X</a></p>
                    </div>
                </div>
            </div>
        </div>

        <book-cards-component
            :book-data="bookData"
            :book-info="bookInfo"
            :user-id="userId"
            :user-connected="userConnected"
            :user-creator="userCreator"
            :visible-criterias="visibleCriterias">
        </book-cards-component>
    </div>
</template>

<script>
import BookCardsComponent from "./BookCardsComponent";
import dayjs from "dayjs";
import UserPopinComponent from "./UserPopinComponent.vue"
import VoteUsefulComponent from "./VoteUsefulComponent.vue"
import SignalAbuseModalComponent from "./SignalAbuseModalComponent";

export default {
    components: {
        BookCardsComponent,
        UserPopinComponent,
        VoteUsefulComponent,
        SignalAbuseModalComponent
    },

    props: {
        bookAuthor: Object,
        bookAuthorAvatar: String,
        bookData: Object,
        bookInfo: Array,
        bookPhoto: String,
        poisCount: Number,
        userId: Number,
        useful: Array,
        userCreator: Boolean,
        userConnected: Boolean,
        userFollowsBook: Boolean,
    },

    data() {
        return {
            filterMenuVisible: false,
            filterCategoryList: [],
            filterCityList: [],
            filterDepartmentList: [],
            userFollowsBookData: false,
            visibleCriterias: [],
        }
    },

    mounted() {
        this.userFollowsBookData = this.userFollowsBook;
        this.setFilters();
    },

    methods: {
        followBook() {
            axios.post(this.route('api.books.follow', [this.bookData]))
                .then(response => {
                    this.userFollowsBookData = !!response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        formatDate(date) {
            return dayjs(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
        },

        searchFilter(e) {
            const searchTerm = e.target.value.toLowerCase();

            this.filterCategoryList = this.filterCategoryList = this.filterCategoryList.filter(item => {
                const regex = new RegExp(searchTerm, 'i');
                return regex.test(item.toLowerCase());
            });

            this.filterDepartmentList = this.filterDepartmentList = this.filterDepartmentList.filter(item => {
                const regex = new RegExp(searchTerm, 'i');
                return regex.test(item.toLowerCase());
            });

            this.filterCityList = this.filterCityList = this.filterCityList.filter(item => {
                const regex = new RegExp(searchTerm, 'i');
                return regex.test(item.toLowerCase());
            });

            if(searchTerm.length === 0) {
                this.setFilters();
            }
        },

        setFilters() {
            if (this.bookInfo.length) {
                for (const card of this.bookInfo) {
                    if (card.poi) {
                        for (const poiSubcategory of card.poi.subcategoriesNames) {
                            if (!this.filterCategoryList.includes(poiSubcategory)) {
                                this.filterCategoryList.push(poiSubcategory);
                            }
                        }

                        if (!this.filterCityList.includes(card.poi.city.name)) {
                            this.filterCityList.push(card.poi.city.name);
                        }

                        if (!this.filterDepartmentList.includes(card.poi.department.name)) {
                            this.filterDepartmentList.push(card.poi.department.name);
                        }
                    }
                }
            }
        },

        setFilterToVisiblecardsList(criteriaType, criteriaName, setter = true) {
            if (setter) {
                if (!this.visibleCriterias.filter(criteria => criteria.type === criteriaType && criteria.name === criteriaName).length) {
                    this.visibleCriterias.push({
                        type: criteriaType,
                        name: criteriaName
                    });
                }
            } else {
                let index = this.visibleCriterias.findIndex(criteria => criteria.type === criteriaType && criteria.name === criteriaName)
                if (index >= 0) {
                    this.visibleCriterias.splice(index, 1)
                }
            }
        },
    },
};
</script>
